export default "__VITE_ASSET__ChcRfyfH__"